
import { Card, CardContent } from "@/components/ui/card";

type ReadingDetailsErrorProps = {
  errorMessage: string;
};

export const ReadingDetailsError = ({ errorMessage }: ReadingDetailsErrorProps) => {
  return (
    <div className="p-4">
      <Card>
        <CardContent className="p-6">
          <p className="text-center text-muted-foreground">
            {errorMessage}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
